/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VideoCallResponse } from '../../models/video-call-response';

export interface GetVideoCall$Params {
  id: number;
  culture: string;
}

export function getVideoCall(http: HttpClient, rootUrl: string, params: GetVideoCall$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoCallResponse>> {
  const rb = new RequestBuilder(rootUrl, getVideoCall.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('culture', params.culture, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VideoCallResponse>;
    })
  );
}

getVideoCall.PATH = '/api/video-call/{id}';
